import { internalPath } from "tr-web";

interface InternalUrlArgs {
  origin: string;
  path: string;
}

/**
 * Takes in an origin and a path, ensures that the path has the proper country
 * and language prefix, and adds the origin to the front of it. In a URL like
 * `https://localhost:3000/locations/atlanta`, the origin is
 * `https://localhost:3000` and the path is `/locations/atlanta`. For more
 * details about URL terminology, see
 * {@link https://stackoverflow.com/a/28049503/1502877 What do you call the entire first part of a URL?}.
 */
export function internalUrl({ origin, path }: InternalUrlArgs) {
  const localizedPath = internalPath(path);
  return new URL(localizedPath, origin).toString();
}
